export const API = "https://swapi.co/api";



// WEBPACK FOOTER //
// ./src/utils/API.js